import React, { useContext, useState, useEffect } from "react";
import { collection, query, where, onSnapshot, orderBy } from "firebase/firestore";

import MainLayout from '../layouts/MainLayout'
import UserInfos from '../components/UserInfos'
import Activities from '../components/Activities'
import Widget from '../components/Widget'
import {AuthContext} from '../services/Session/Context'
import {FirebaseContext} from '../services/Firebase/Context'
import FeedbacksCard from '../components/FeedbacksCard';

const Home = () => {
  const { user } = useContext(AuthContext)
  const { db } = useContext(FirebaseContext)
  const [recordsNew, setRecordsNew] = useState([])
  const [recordsPending, setRecordsPending] = useState([])
  const [recordsEnded, setRecordsEnded] = useState([])
  const [appointments, setAppointments] = useState([])

  useEffect(() => {
    if(!user) return
    const qNew = query(collection(db, "records"), where("organisationId", "==", user.organisationId), where("status", "==", "new"), orderBy("createdAt", 'desc'));
    const unsubscribeNew = onSnapshot(qNew, (querySnapshot) => {
      const records = [];
      querySnapshot.forEach((doc) => {
        records.push({id: doc.id, ...doc.data()});
      });
      setRecordsNew(records)
    });
    const qPending = query(collection(db, "records"), where("organisationId", "==", user.organisationId), where("status", "==", "pending"), orderBy("pendingAt", 'desc'));
    const unsubscribePending = onSnapshot(qPending, (querySnapshot) => {
      const records = [];
      querySnapshot.forEach((doc) => {
        records.push({id: doc.id, ...doc.data()});
      });
      setRecordsPending(records)
    });
    
    // Only get ended records for today
    const d = new Date();
    d.setHours(0,0,0,0);
    const qEnded = query(
      collection(db, "records"),
      where("organisationId", "==", user.organisationId),
      where("status", "==", "ended"),
      where("endedAt", ">", d),
      orderBy("endedAt", 'desc')
    );
    const unsubscribeEnded = onSnapshot(qEnded, (querySnapshot) => {
      const records = [];
      querySnapshot.forEach((doc) => {
        records.push({id: doc.id, ...doc.data()});
      });
      setRecordsEnded(records)
    });

    const qAppointments = query(collection(db, "appointments"), where("organisationId", "==", user.organisationId), where("status", "==", "new"), orderBy("createdAt", 'desc'));
    const unsubscribeAppointments = onSnapshot(qAppointments, (querySnapshot) => {
      const records = [];
      querySnapshot.forEach((doc) => {
        const dataRec = doc.data()
        records.push({
          id: doc.id,
          customerName: dataRec.name,
          createdAt: dataRec.createdAt,
          status: dataRec.status,
          customerBusiness: dataRec.isBusiness
        });
      });
      setAppointments(records)
    });

    return () => {
      unsubscribeNew()
      unsubscribePending()
      unsubscribeEnded()
      unsubscribeAppointments()
    }
  }, [db, user])

  return (
    <MainLayout>
      <UserInfos/>
      <h1 className="text-4xl font-semibold text-gray-800 dark:text-white">Bienvenue, {user.firstName}</h1>
      <h2 className=" text-gray-400">Voici ce qui se passe dans votre garage actuellement.</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 my-6">
        <Widget title='Rendez-vous'  subtitle="(Non confirmé)" items={appointments}/>
        <Widget title='Nouvelles arrivées' items={recordsNew}/>
        <Widget title='En cours' items={recordsPending}/>
        <Widget title='Terminée' subtitle="(Aujourd'hui)" items={recordsEnded}/>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-6">
        <div className="col-span-2"><Activities /></div>
        <div className="col-span-1"><FeedbacksCard /></div>
      </div>
      {/*  WIDGET durée de la dernière intervention du jour pending to ended at*/}
      {/*  WIDGET durée moyenne des interventions du jours pending to ended at */}
      {/*  WIDGET durée de la dernière prise en charge du jour new to pending at*/}
      {/*  WIDGET durée moyenne des prise en charge du jours new to pending at */}
    </MainLayout>
  );
}

export default Home
